import constants from '~/utils/constants';
import type { RoutesDrawerFilterMapMode } from './types';

export const isValidFilterMapMode = (
    mapMode: string
): mapMode is RoutesDrawerFilterMapMode => {
    const validMapRouteModes: string[] = [
        constants.mapRouteModes.PLAN,
        constants.mapRouteModes.DISPATCHED,
        constants.mapRouteModes.COMPLETED
    ];

    return validMapRouteModes.includes(mapMode);
};
